<ion-header>
    <ion-toolbar class="ion-padding-end">
        <ion-title i18n=":@@merchant_search_table.page-title">Gestores</ion-title>

        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>

    </ion-toolbar>

    <ion-toolbar>
        <ion-segment [value]="Mode" (ionChange)="OnChangeMode($event)">

            <ion-segment-button [value]="EnumSelectManagerProfileMode.Available">
                <ion-label i18n=":@@merchant_search_table.tab-search">Disponíveis</ion-label>
            </ion-segment-button>

            <ion-segment-button [value]="EnumSelectManagerProfileMode.Create" *ngIf="HasCreateOption">
                <ion-label i18n=":@@merchant_search_table.tab-create">Criar utilizador</ion-label>
            </ion-segment-button>

            <ion-segment-button [value]="EnumSelectManagerProfileMode.SearchUsers" *ngIf="HasSearchUsersOption">
                <ion-label i18n=":@@merchant_search_table.tab-search-users">Utilizadores</ion-label>
            </ion-segment-button>

        </ion-segment>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding padding-horizontal">

    <!-- SEARCH MODE -->
    <ng-container *ngIf="Mode === EnumSelectManagerProfileMode.Available">

        <ion-grid class="table">

            <ion-row class="table-header">
                <ion-col class="flex-align-center" i18n=":@@merchant_search_table.name">Nome</ion-col>
                <ion-col size="3" class="flex-align-center" i18n=":@@merchant_search_table.vatnumber">NIF</ion-col>
                <ion-col size="3" class="flex-align-center" i18n=":@@merchant_search_table.profile">Perfil</ion-col>
                <ion-col size="2" class="flex-align-center"></ion-col>
            </ion-row>

            <ng-container *ngFor="let item of Data;">

                <!-- linha 1: dados do utilizador -->
                <ion-row class="table-body with-button-opacity">
                    <ion-col class="flex-align-center">{{ item?.User?.Name || '--' }}</ion-col>
                    <ion-col size="3" class="flex-align-center">{{ item?.VatNumber || '--' }}</ion-col>
                    <ion-col size="3" class="flex-align-center">{{ item?.Role?.Name || '--' }}</ion-col>
                    <ion-col size="2" class="flex-justify-end">

                        <ion-button fill="clear" size="small" *ngIf="item?.MerchantList?.length > 0"
                            (click)="ToggleMerchantList(item)"
                            [title]="IsMerchantListExpanded(item) ? 'Ocultar lojas' : 'Ver lojas'">
                            <ion-icon slot="icon-only"
                                [name]="IsMerchantListExpanded(item) ? 'chevron-up-outline' : 'chevron-down-outline'">
                            </ion-icon>
                        </ion-button>

                        <ion-button fill="clear" size="small" (click)="OnSaveAssociation(item)"
                            [disabled]="IsAssociatedToCurrentMerchant(item)"
                            [title]="IsAssociatedToCurrentMerchant(item) ? 'Já associado' : 'Associar'">
                            <ion-icon name="add-outline" slot="icon-only"></ion-icon>
                        </ion-button>

                    </ion-col>
                </ion-row>

                <!-- linha 2: lojas/comerciantes associados -->
                <ion-row class="table-body stores-row" *ngIf="IsMerchantListExpanded(item)">
                    <ion-col size="12" class="chip-list" style="padding: 16px !important;">
                        <ion-chip *ngFor="let store of item?.MerchantList" outline color="success">
                            {{ store?.Merchant?.Name || '--' }}
                        </ion-chip>
                    </ion-col>
                </ion-row>

            </ng-container>

            <div class="empty-state" *ngIf="Data?.length==0">
                <ion-icon name="search-outline"></ion-icon>
                <p i18n=":@@merchant_search_table.no-it">sem dados</p>
            </div>

        </ion-grid>

    </ng-container>

    <!-- SEARCH USERS MODE -->
    <ng-container *ngIf="Mode === EnumSelectManagerProfileMode.SearchUsers">
        <ion-toolbar>
            <ion-searchbar #filterText [value]="Filters?.Text" placeholder="pesquisar" (ionClear)="OnSearch($event)"
                (keyup.enter)="OnSearch($event, filterText?.value)">
            </ion-searchbar>

            <ion-buttons slot="end">
                <ion-button fill="clear" color="primary" (click)="OnSearch($event, filterText?.value)">
                    <ion-icon slot="icon-only" name="search-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>

        <ion-grid class="table">

            <ion-row class="table-header">
                <ion-col class="flex-align-center" i18n=":@@merchant_search_table.name">Nome</ion-col>
                <ion-col size="4" class="flex-align-center" i18n=":@@merchant_search_table.manager">Email</ion-col>
                <ion-col size="2" class="flex-align-center"></ion-col>
            </ion-row>

            <ng-container *ngFor="let item of ExistingUsersData;">
                <ion-row class="table-body with-button-opacity">
                    <ion-col class="flex-align-center">{{ item?.Name || '--'}}</ion-col>
                    <ion-col size="4" class="flex-align-center">{{ item?.Email || '--' }}</ion-col>
                    <ion-col size="2" class="flex-justify-end">
                        <ion-button fill="clear" size="small" (click)="OnSaveAssociation(item)">
                            <ion-icon name="add-outline" slot="icon-only"></ion-icon>
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ng-container>

            <div class="empty-state" *ngIf="ExistingUsersData?.length==0">
                <ion-icon name="search-outline"></ion-icon>
                <p i18n=":@@merchant_search_table.no-it-users">procure pelo nome de utilizador</p>
            </div>

        </ion-grid>

    </ng-container>

    <!-- CREATE MODE -->
    <ng-container *ngIf="Mode === EnumSelectManagerProfileMode.Create">

        <ion-grid>

            <form [formGroup]="CreateForm" class="ion-padding">

                <ion-row>
                    <ion-col size="12">
                        <ion-item lines="full">
                            <ion-label position="stacked" i18n=":@@merchant_create_manager.name"
                                required>Nome</ion-label>
                            <ion-input formControlName="Name" type="text" placeholder="Nome completo"></ion-input>
                        </ion-item>
                        <form-errors [control]="CreateForm.get('Name')"></form-errors>
                    </ion-col>
                </ion-row>

                <ion-row>
                    <ion-col size="12" sizeMd="8">
                        <ion-item lines="full">
                            <ion-label position="stacked" i18n=":@@merchant_create_manager.email"
                                required>Email</ion-label>
                            <ion-input formControlName="Email" type="email" placeholder="email@exemplo.com"></ion-input>
                        </ion-item>
                        <form-errors [control]="CreateForm.get('Email')"></form-errors>
                    </ion-col>

                    <ion-col size="12" sizeMd="4">
                        <ion-item lines="none" fill="outline">
                            <ion-label position="stacked" i18n=":@@merchant_create_manager.profile"
                                required>Perfil</ion-label>

                            <ion-select class="outline" formControlName="IdTemplate" interface="popover"
                                placeholder="Selecionar perfil">
                                <ion-select-option *ngFor="let profile of Profiles" [value]="profile?.Template?.Id">
                                    {{ profile?.Template?.Name }}
                                </ion-select-option>
                            </ion-select>
                        </ion-item>
                        <form-errors [control]="CreateForm.get('IdTemplate')"></form-errors>
                    </ion-col>
                </ion-row>

                <ion-row class="full ion-margin-top">
                    <ion-col size="12">
                        <ion-item lines="none" button detail="false" (click)="ShowExtraData=!ShowExtraData">
                            <ion-label i18n=":@@merchant_create_manager.extra-data">Mais informação</ion-label>
                            <ion-icon slot="end" [name]="ShowExtraData ? 'chevron-up-outline' : 'chevron-down-outline'">
                            </ion-icon>
                        </ion-item>
                    </ion-col>
                </ion-row>

                <ion-row *ngIf="ShowExtraData">
                    <ion-col>

                        <ion-grid class="full">

                            <ion-row class="ion-margin-top">
                                <ion-col size="12" sizeMd="4">
                                    <ion-item lines="full">
                                        <ion-label position="stacked" i18n=":@@merchant_create_manager.vatnumber">NIF
                                        </ion-label>
                                        <ion-input formControlName="VatNumber"></ion-input>
                                    </ion-item>
                                    <form-errors [control]="CreateForm.get('VatNumber')"></form-errors>
                                </ion-col>

                                <ion-col size="12" sizeMd="4">
                                    <ion-item lines="none" fill="outline">
                                        <ion-label position="stacked" i18n=":@@merchant_create_manager.birthday">Data
                                            nascimento
                                        </ion-label>

                                        <ion-input [id]="'datepicker-select-manager-profile-dateBirthday'"
                                            [disabled]="CreateForm.get('BirthDate').disabled" inputmode="none"
                                            [value]="(CreateForm.get('BirthDate').value|date:'dd-MM-yyyy')" button
                                            readonly>
                                            <ion-icon slot="end" name="calendar-outline"></ion-icon>
                                        </ion-input>

                                        <ion-popover [trigger]="'datepicker-select-manager-profile-dateBirthday'"
                                            show-backdrop="false">
                                            <ng-template>
                                                <ion-datetime presentation="date" locale="pt" mode="md"
                                                    [max]="MinValidityDate" formControlName="BirthDate"
                                                    [showDefaultButtons]="false">
                                                </ion-datetime>
                                            </ng-template>
                                        </ion-popover>

                                    </ion-item>
                                    <form-errors [control]="CreateForm.get('BirthDate')"></form-errors>
                                </ion-col>

                                <ion-col size="12" sizeMd="4">
                                    <ion-item lines="full" fill="outline">
                                        <ion-label position="stacked" i18n=":@@merchant_create_manager.genre">Género
                                        </ion-label>

                                        <ion-select [interface]="'popover'" class="outline" formControlName="IdGender"
                                            style="max-width: calc(100% - 12px);">
                                            <ion-select-option [value]="EnumUserGenre.Undefined">Não
                                                definido</ion-select-option>
                                            <ion-select-option
                                                [value]="EnumUserGenre.Male">Masculino</ion-select-option>
                                            <ion-select-option
                                                [value]="EnumUserGenre.Female">Feminino</ion-select-option>
                                        </ion-select>

                                    </ion-item>
                                    <form-errors [control]="CreateForm.get('IdGender')"></form-errors>
                                </ion-col>
                            </ion-row>

                            <ion-row class="ion-margin-top">
                                <ion-col size="12" sizeMd="6">
                                    <ion-item lines="full" fill="outline">
                                        <ion-label position="stacked" i18n=":@@merchant_create_manager.docNumber">
                                            Documento de identificação
                                        </ion-label>

                                        <ion-grid class="full">
                                            <ion-row>
                                                <ion-col style="max-width: 160px;">
                                                    <ion-select [interface]="'popover'" class="outline"
                                                        formControlName="IdDocumentType"
                                                        style="max-width: calc(100% - 12px);">
                                                        <ion-select-option
                                                            [value]="UserDocumentType.BI">BI</ion-select-option>
                                                        <ion-select-option
                                                            [value]="UserDocumentType.CC">CC</ion-select-option>
                                                        <ion-select-option
                                                            [value]="UserDocumentType.PASSPORT">Passaporte</ion-select-option>
                                                    </ion-select>
                                                </ion-col>
                                                <ion-col>
                                                    <ion-input
                                                        formControlName="IdentificationDocumentNumber"></ion-input>
                                                </ion-col>
                                            </ion-row>
                                        </ion-grid>

                                    </ion-item>
                                    <form-errors
                                        [control]="CreateForm.get('IdentificationDocumentNumber')"></form-errors>
                                </ion-col>

                                <ion-col size="12" sizeMd="6">
                                    <ion-item lines="none" fill="outline">
                                        <ion-label position="stacked"
                                            i18n=":@@merchant_create_manager.docNumberDate">Validade do
                                            Documento
                                        </ion-label>
                                        <ion-input [id]="'datepicker-select-manager-profile-dateEmission'"
                                            [disabled]="CreateForm.get('IdentificationDocumentValidityDate').disabled"
                                            inputmode="none"
                                            [value]="(CreateForm.get('IdentificationDocumentValidityDate').value|date:'dd-MM-yyyy')"
                                            button readonly>
                                            <ion-icon slot="end" name="calendar-outline"></ion-icon>
                                        </ion-input>

                                        <ion-popover [trigger]="'datepicker-select-manager-profile-dateEmission'"
                                            show-backdrop="false">
                                            <ng-template>
                                                <ion-datetime presentation="date" locale="pt" mode="md"
                                                    [min]="MinValidityDate" [max]="MaxValidityDate"
                                                    formControlName="IdentificationDocumentValidityDate"
                                                    [showDefaultButtons]="false">
                                                </ion-datetime>
                                            </ng-template>
                                        </ion-popover>

                                    </ion-item>
                                    <form-errors
                                        [control]="CreateForm.get('IdentificationDocumentValidityDate')"></form-errors>
                                </ion-col>
                            </ion-row>

                            <ion-row class="ion-margin-top">
                                <ion-col size="12" sizeMd="6">
                                    <ion-item lines="full" fill="outline">
                                        <ion-label position="stacked" i18n=":@@merchant_create_manager.phone">Telefone
                                        </ion-label>
                                        <ion-input formControlName="Phone"></ion-input>
                                    </ion-item>
                                    <form-errors [control]="CreateForm.get('Phone')"></form-errors>
                                </ion-col>

                                <ion-col size="12" sizeMd="6">
                                    <ion-item lines="full" fill="outline">
                                        <ion-label position="stacked"
                                            i18n=":@@merchant_create_manager.mobilephone">Telemóvel
                                        </ion-label>
                                        <ion-input formControlName="MobilePhone"></ion-input>
                                    </ion-item>
                                    <form-errors [control]="CreateForm.get('MobilePhone')"></form-errors>
                                </ion-col>
                            </ion-row>

                            <ion-row class="ion-margin-top">
                                <ion-col size="12" sizeMd="4">
                                    <ion-item lines="full" fill="outline">
                                        <ion-label position="stacked" i18n=":@@merchant_create_manager.nationality">País
                                            de origem
                                        </ion-label>
                                        <ion-select [interface]="'popover'" class="outline"
                                            formControlName="IdNationality" style="max-width: calc(100% - 12px);">
                                            <ion-select-option *ngFor="let item of Countries"
                                                [value]="item?.Id">{{item.Name}}</ion-select-option>
                                        </ion-select>
                                    </ion-item>
                                    <form-errors [control]="CreateForm.get('IdNationality')"></form-errors>
                                </ion-col>

                            </ion-row>



                        </ion-grid>

                    </ion-col>
                </ion-row>

            </form>

        </ion-grid>

    </ng-container>

</ion-content>

<ion-footer *ngIf="Mode === EnumSelectManagerProfileMode.Create">
    <ion-toolbar class="ion-padding-horizontal">
        <ion-button slot="end" style="margin-right: -16px;" fill="solid" color="medium" [disabled]="IsSubmitting"
            (click)="OnSubmitCreate()">
            <ion-spinner *ngIf="IsSubmitting" name="crescent" slot="start"></ion-spinner>
            <span i18n=":@@merchant_create_manager.submit">Criar e associar</span>
        </ion-button>
    </ion-toolbar>
</ion-footer>